<div class="main_content">
    <!-- <app-breadcrumb></app-breadcrumb> -->
    <div #page_section class="page_main_sec">
        <h1>
            <div class="reportTitle">
                {{reportName}}
            </div>
        </h1>
        <div class="OpenSearch_main_sec">
            <div class="container-fluid">
                <div class="row criteria-sec">
                    <div [formGroup]="frmReport">
                        <div *ngFor="let field of tbl_filter_design" [ngSwitch]="field.FILTER_CONTROL"
                            class="col-lg-3 f_lft mgr_20">

                            <mat-form-field *ngSwitchCase="'TEXTBOX'" [style.width.%]="100">
                                <mat-label for="{field.FILTER_NAME}">
                                    {{ field.FILTER_NAME }}
                                    <span *ngIf="field.IS_MANDATORY == 1" class="field-mandatory">*</span>
                                </mat-label>

                                <input matInput *ngIf="field.FILTER_TYPE=='text'" [id]="field.FILTER_NAME"
                                    [formControlName]="field.FILTER_NAME" />
                            </mat-form-field>

                            <ng-container *ngSwitchCase="'CALENDAR'">
                                <ng-container *ngIf="field.FILTER_TYPE == 'RANGE'">
                                    <mat-form-field [style.width.%]="100">
                                        <mat-date-range-input [rangePicker]="picker" id="Daterange" [attr.role]="null">
                                            <input matStartDate placeholder="Start date" title="Start date"
                                                [formControlName]="field.FILTER_NAME" required readonly>
                                            <input matEndDate placeholder="End date" title="End date"
                                                [formControlName]="ToDate" required readonly>
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker></mat-date-range-picker>
                                        <mat-label for="Daterange">
                                            {{ field.FILTER_NAME }}
                                            <span *ngIf="field.IS_MANDATORY == 1" class="field-mandatory">*</span>
                                        </mat-label>
                                    </mat-form-field>
                                </ng-container>
                                <ng-container *ngIf="field.FILTER_TYPE == 'DATE'">
                                    <mat-form-field [style.width.%]="100">
                                        <mat-label for="{field.FILTER_NAME}">
                                            {{ field.FILTER_NAME }}
                                            <span *ngIf="field.IS_MANDATORY == 1" class="field-mandatory">*</span>
                                        </mat-label>

                                        <input matInput readonly [formControlName]="field.FILTER_NAME"
                                            [id]="field.FILTER_NAME" [matDatepicker]="picker"
                                            [placeholder]="field.FILTER_NAME">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </ng-container>
                            </ng-container>

                            <mat-form-field *ngSwitchCase="'DROPDOWN'" appearance="legacy" [style.width.%]="100">
                                <mat-label for="{field.FILTER_NAME}">{{ field.FILTER_NAME}}
                                    <span *ngIf="field.IS_MANDATORY == 1" class="field-mandatory">*</span>
                                </mat-label>
                                <mat-select [formControlName]="field.FILTER_NAME" [id]="field.FILTER_NAME"
                                    [attr.role]="null">
                                    <mat-option *ngFor="let option of field.options" [value]="option.DROPDOWN_VALUE">
                                        {{option.DROPDOWN_TEXT}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngSwitchCase="'MULIPLECHECKBOX'" appearance="legacy" [style.width.%]="100">
                                <mat-label for="{field.FILTER_NAME}">{{ field.FILTER_NAME}}
                                    <span *ngIf="field.IS_MANDATORY == 1" class="field-mandatory">*</span></mat-label>
                                <mat-select [formControlName]="field.FILTER_NAME" multiple [id]="field.FILTER_NAME"
                                    [attr.role]="null">
                                    <mat-option *ngFor="let option of field.options"
                                        [value]="option.DROPDOWN_VALUE">{{option.DROPDOWN_TEXT}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <!-- <div class="post-nav-wrap">
                    <div class="title-wrap">
                        <p class="title">{{reportName}}</p>
                    </div>
                    <ul class="nav top-actions">
                        <li>
                            <a [routerLink]="['/home']">
                                <i class="fa fa-home theme-text-color"></i>
                            </a>
                        </li>
                    </ul>
                </div> -->
            </div>
        </div>

        <div class="tab-content">
            <div class="table_card_sec">
                <div class="btn-opensearch">
                    <button type="button" class="btncss me-2 btn_primary" (click)="GetDatabasedOnFlag();">
                        Refresh
                    </button>
                    <button type="button" class="btncss me-2 btn_primary" (click)="generateOfflineReport();">
                        Generate Report
                    </button>
                </div>
            </div>

            <div class="grid_panel">
                <div class="reportBack">
                    <input *ngIf="isBackRequest==true" type="button" class="btn resetButton btnFormat" value="Back"
                        (click)="loadBack()">
                </div>
                <div *ngIf="lstData.length>0">
                    <app-basic-gridview [lstData]="lstData" [columnsToHide]="columnsToHide" [gridTitle]="reportName"
                        [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                        [showPagination]="true" (cellClickEvent)="onGridCellClick($event)"
                        [hyperlinkCols]="hyperlinkCols" [exportToExcelFileName]="reportName"
                        [columnsToExcludeFromExport]="[]">
                    </app-basic-gridview>
                </div>

            </div>
        </div>
    </div>
</div>